/**
 *
 * @param {string} theme
 * @param {string} lang
 * @return {Object}
 */

export const MainTheme = {
	dark: {
		mainBg: '#0A0118',
		primaryBg: '#252525',
		color: '#4b5563',
		inputPlaceHolder: "#b9b9b9",
		secondary: '#eaecef',
		primary: '#9CA3AF',
		hover: '#26282b70',
		active: '#ffc800',
		activeSidebarItem: '#2A2A2A',
		exitRed: '#a12356',
		mainOrange: '#FF6700',
		mainRed: '#e9106c',
		mainGreen: '#1ce087',
		search: '#161a1e',
		input: '#252525',
		textArea: '#44464c',
		dropdown: '#36383C',
		black: '#000000',
		tInputBg: '#2a2d35',
		profileTitle: '#ffc800',
		headerBg: "#191c20",
		textColor: "#e0e0e0",
		main: "#ffc800",
		tradeBg: "#1e2026",
		otcInput: "#0e111a",
		mChart: "#131722",
		orderHover: "#5e6673",
		inActive: '#72747830',
		kayaHover: '#ffffff10',
		colorHeaderIconHover: '#FFFFFF19',
		colorHeaderIcon: '#2A2A2A',
		headerShadow: "#00000029",
		settingBg: '#1E1533',
		mainHightContrast: '#D5a700',
		iconColor: "#FFFFFF",
		cardBorder: "#4b5563",
		fieldBg: '#2A2A2A',
		// 
		globalBg: "#000000",
		mainColor: "#9F64DF",
		cardBg: "#0F0524",
		secondaryBg: "#1E1533",
		purpleBorder: "#563B73",
		primaryOrange: "#FC6432",
		inputBorder: "#FFCEF3",
		checkbox: '#FFCEF3',
		modalBg: "#101828",
		tableHeaderBg: "#0F0524",
		tableRowBg: "#0F0524",
		secondaryColor: "#8481BD"
	},
	light: {
		mainBg: "#F5F5F5",
		primaryBg: "#ffffff",
		color: "#DDDDDD",
		secondary: "#595e67",
		primary: "#595e67",
		hover: "#fafafa70",
		active: "#ffc800",
		activeSidebarItem: '#E0E0E0',
		exitRed: "#a12356",
		mainOrange: "#FF6700",
		mainRed: "#d54a61",
		mainGreen: "#008e47",
		search: "#f0f1f2",
		input: "#FFFFFF",
		textArea: "#f0f1f2",
		dropdown: "#f0f1f2",
		tradeBg: "#ffffff",
		otcInput: "#f0f1f2",
		black: "#000000",
		orderHover: "#5e6673",
		tInputBg: "#f0f1f2",
		profileTitle: '#50514c',
		headerBg: "#fff",
		headerShadow: "#ccc",
		textColor: "#061222",
		main: "#ffc800",
		mChart: "wheat",
		inActive: '#72747830',
		kayaHover: '#00000010',
		colorHeaderIcon: '#E2E2E2',
		colorHeaderIconHover: '#00000019',
		settingBg: '#fafafa',
		mainHightContrast: '#D5a700',
		iconColor: "#1E1E1E",
		cardBorder: "#dddddd",
		fieldBg: "#F7F7F7",
		// 
		globalBg: "#000000",
		mainColor: "#9F64DF",
		secondaryBg: "#1E1533",
		purpleBorder: "#563B73",
		cardBg: "#fafafa",
		primaryOrange: "#FC6432",
		inputBorder: "#FFCEF3",
		checkbox: '#FFCEF3',
		modalBg: "#101828",
		tableHeaderBg: "#131519",
		tableRowBg: "#262433",
		secondaryColor: "#8481BD"

	}
};

const getMainTheme = (theme = 'dark', lang = 'en') => {

	return {
		...MainTheme[theme],
		english: lang === "en",
		lang,
		dir: lang === "fa" ? "rtl" : "ltr",
	}

}



export {
	getMainTheme
}
